/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetTypeShortResponseDto
 */
export interface AssetTypeShortResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetTypeShortResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetTypeShortResponseDto
     */
    name: string;
}

/**
 * Check if a given object implements the AssetTypeShortResponseDto interface.
 */
export function instanceOfAssetTypeShortResponseDto(value: object): value is AssetTypeShortResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AssetTypeShortResponseDtoFromJSON(json: any): AssetTypeShortResponseDto {
    return AssetTypeShortResponseDtoFromJSONTyped(json, false);
}

export function AssetTypeShortResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetTypeShortResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function AssetTypeShortResponseDtoToJSON(json: any): AssetTypeShortResponseDto {
    return AssetTypeShortResponseDtoToJSONTyped(json, false);
}

export function AssetTypeShortResponseDtoToJSONTyped(value?: AssetTypeShortResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

